"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _assets = require("../../../utils/assets");
var _objects = require("../../../utils/objects");
var actions = _interopRequireWildcard(require("../actionTypes"));
var utils = _interopRequireWildcard(require("./utils"));
var _actionTypes2 = require("../../categories/actionTypes");
var _utils2 = require("../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var initialState = {
  data: {},
  ui: {
    isDeletingAsset: false
  },
  promises: {}
};
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var assetPath = (0, _assets.getGAKey)(action);
  switch (action.type) {
    case actions.UPDATE_METADATA.SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, assetPath, _objectSpread(_objectSpread({}, state.data[assetPath]), action.params.metadata)))
        });
      }
    case actions.UPDATE_NAME.SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, assetPath, _objectSpread(_objectSpread({}, state.data[assetPath]), {}, {
            name: action.params.name
          })))
        });
      }
    case actions.UPDATE_DESCRIPTION.SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, assetPath, _objectSpread(_objectSpread({}, state.data[assetPath]), {}, {
            description: action.params.description
          })))
        });
      }
    case actions.UPDATE_CONTACT_NAME.SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, assetPath, _objectSpread(_objectSpread({}, state.data[assetPath]), {}, {
            contactName: action.params.contactName
          })))
        });
      }
    case actions.UPDATE_CONTACT_EMAIL.SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, assetPath, _objectSpread(_objectSpread({}, state.data[assetPath]), {}, {
            contactEmail: action.params.contactEmail
          })))
        });
      }
    case actions.UPDATE_ICON.SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, assetPath, utils.updateIcon(state.data[assetPath], action.result.externalLink)))
        });
      }
    case _actionTypes2.REMOVE_CATEGORY:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          data: utils.updateCategories(state, function (categories) {
            return categories.filter(function (category) {
              return category.key !== action.tagKey;
            });
          })
        });
      }
    case _actionTypes2.UPDATE_CATEGORY:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          data: utils.updateCategories(state, function (categories, type) {
            return categories.map(function (category) {
              var newCategory = _objectSpread({}, category);
              if (category.key === action.tagKey) {
                var validCategoryValues = category.value.filter(function (value) {
                  return action.acceptedValues.includes(value);
                });
                var validType = !action.assetTypeRestrictions.length ? true : action.assetTypeRestrictions.includes(type);
                newCategory.value = validType ? validCategoryValues : [];
              }
              return newCategory;
            }).filter(function (category) {
              return category.value.length;
            });
          })
        });
      }
    case actions.DELETE_ICON.SUCCESS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          data: _objectSpread(_objectSpread({}, state.data), {}, (0, _defineProperty2.default)({}, assetPath, utils.deleteIcon(state.data[assetPath])))
        });
      }
    case actions.FETCH_ASSET.REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          promises: _objectSpread((0, _defineProperty2.default)({}, (0, _utils2.getIdentifierPath)(action), action.assetPromise), state.promises)
        });
      }
    case actions.FETCH_ASSET.FAILURE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          promises: (0, _objects.omit)(state.promises, (0, _utils2.getIdentifierPath)(action))
        });
      }
    case actions.CREATE_ASSET.SUCCESS:
    case actions.FETCH_ASSET.SUCCESS:
      {
        var newState = state;
        newState = action.asset.dependencies.reduce(utils.mergeIncompleteVersion, newState);
        newState = action.asset.versions.reduce(utils.mergeIncompleteVersion, newState);
        newState = utils.mergeVersion(newState, _objectSpread(_objectSpread({}, action.asset), {}, {
          isCompleted: true,
          // TODO: when navigation by minor versions is enabled, isCompleted value should be removed from everywhere
          isMinorVersionTransition: false,
          isDeleted: false
        }));
        return _objectSpread(_objectSpread({}, newState), {}, {
          promises: (0, _objects.omit)(state.promises, (0, _utils2.getIdentifierPath)(action))
        });
      }
    case actions.UPDATE_LABELS.REQUEST:
      {
        return utils.mergeVersion(state, _objectSpread(_objectSpread({}, action.params), {}, {
          labels: action.params.labels
        }));
      }
    case actions.UPDATE_ASSET_CATEGORIES.REQUEST:
    case actions.UPDATE_ASSET_CATEGORIES.FAILURE:
      {
        return utils.mergeVersion(state, action.asset);
      }
    case actions.UPDATE_RATING:
      {
        return utils.mergeVersion(state, action.asset);
      }
    case actions.CLEAR_DELETE_ASSET_ERROR:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            hasDeleteError: false
          })
        });
      }
    case actions.DELETE_ASSET.REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isDeletingAsset: true
          })
        });
      }
    case actions.DELETE_ASSET_DETAIL:
      {
        return _objectSpread({}, utils.mergeVersion(state, _objectSpread(_objectSpread({}, action.asset), {}, {
          isDeleted: true
        })));
      }
    case actions.DELETE_ASSET.SUCCESS:
      {
        var _asset;
        var asset = action.asset;
        if (!((_asset = asset) !== null && _asset !== void 0 && _asset.minorVersion)) {
          asset = (0, _objects.omit)(action.asset, 'minorVersion');
        }
        return _objectSpread(_objectSpread({}, utils.mergeVersion(state, _objectSpread(_objectSpread({}, asset), {}, {
          isDeleted: true
        }))), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isDeletingAsset: false
          })
        });
      }
    case actions.DELETE_ASSET.FAILURE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isDeletingAsset: false
          })
        });
      }
    case actions.DELETE_ASSET_CONFLICT_DUE_TO_DEPENDENTS:
      {
        return _objectSpread(_objectSpread({}, utils.mergeVersion(state, action.asset)), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isDeletingAsset: false,
            hasDeleteError: true
          })
        });
      }
    case actions.UPDATE_STATUS.SUCCESS:
      {
        return _objectSpread({}, utils.mergeVersion(state, _objectSpread(_objectSpread({}, action.params.asset), {}, {
          status: action.params.status
        })));
      }
    case actions.DEPRECATE_ASSET.SUCCESS:
      {
        if (action.params.minorVersion) {
          return _objectSpread(_objectSpread({}, utils.updateMinor(state, action.params, {
            status: 'deprecated'
          })), {}, {
            ui: _objectSpread(_objectSpread({}, state.ui), {}, {
              isDeprecatingAsset: false
            })
          });
        }
        return _objectSpread(_objectSpread({}, utils.mergeVersion(state, _objectSpread(_objectSpread({}, action.params), {}, {
          status: 'deprecated'
        }))), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isDeprecatingAsset: false
          })
        });
      }
    case actions.DEPRECATE_ASSET.FAILURE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            onDeprecateError: true,
            isDeprecatingAsset: false
          })
        });
      }
    case actions.DEPRECATE_ASSET.REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isDeprecatingAsset: true
          })
        });
      }
    case actions.REVERT_DEPRECATE_ASSET.SUCCESS:
      {
        if (action.params.minorVersion) {
          return _objectSpread(_objectSpread({}, utils.updateMinor(state, action.params, {
            status: 'published'
          })), {}, {
            ui: _objectSpread(_objectSpread({}, state.ui), {}, {
              isRevertingDeprecateAsset: false
            })
          });
        }
        return _objectSpread(_objectSpread({}, utils.mergeVersion(state, _objectSpread(_objectSpread({}, action.params), {}, {
          status: 'published'
        }))), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isRevertingDeprecateAsset: false
          })
        });
      }
    case actions.REVERT_DEPRECATE_ASSET.FAILURE:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            onRevertDeprecateError: true,
            isRevertingDeprecateAsset: false
          })
        });
      }
    case actions.REVERT_DEPRECATE_ASSET.REQUEST:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          ui: _objectSpread(_objectSpread({}, state.ui), {}, {
            isRevertingDeprecateAsset: true
          })
        });
      }
    case actions.GET_LIFECYCLE_STATES_ACTIONS.SUCCESS:
      {
        var result = action.result;
        return _objectSpread({}, utils.mergeVersion(state, _objectSpread(_objectSpread({}, action.params), {}, {
          lifecycleStateActions: result
        })));
      }
    default:
      return state;
  }
}
//# sourceMappingURL=detail.js.map